import { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import {
  TruckThinIcon,
  SmileIcon,
  PercentageStarIcon,
  ReturnsThinIcon,
  WineBottlesIcon,
  PriceTagIcon,
} from "@vinomofo/icons";

const fadeInOut = keyframes`
  0% { opacity: 0; }
  40% { opacity: 1; }
  60% { opacity: 1; }
  100% { opacity: 0; }
`;

const marketPromises = {
  AU: [
    [
      {
        Icon: WineBottlesIcon,
        label: "bottles delivered",
        stats: "33.3 million",
      },
      { Icon: SmileIcon, label: "happy mofos worldwide", stats: "779k" },
      {
        Icon: PercentageStarIcon,
        label: "average saving off RRP",
        stats: "66.1%",
      },
    ],
    [
      { Icon: PriceTagIcon, label: "Epic deals" },
      { Icon: TruckThinIcon, label: "Free shipping on 3+ cases" },
      { Icon: ReturnsThinIcon, label: "Free returns" },
    ],
  ],
  SG: [
    [
      {
        Icon: WineBottlesIcon,
        label: "bottles delivered",
        stats: "662k",
      },
      { Icon: SmileIcon, label: "happy mofos worldwide", stats: "43k" },
      {
        Icon: PercentageStarIcon,
        label: "average saving off RRP",
        stats: "65.3%",
      },
    ],
    [
      { Icon: PriceTagIcon, label: "Epic wine deals" },
      { Icon: TruckThinIcon, label: "Free shipping on orders over $200" },
      { Icon: ReturnsThinIcon, label: "Free returns" },
    ],
  ],
};

const MofoPromisesContainer = styled.div`
  background-color: #ffffff;
  border-bottom: 1px solid #dadada;
  padding: 0 15px;
`;

const MofoPromisesInner = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 1140px;
  position: relative;
  height: 36px;
`;

const MofoPromisesGroup = styled.div`
  @media ${({ theme }) => theme.mq.min.tablet} {
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 1s ease-in-out;
    opacity: ${(props) => (props.isActive ? "1" : "0")};
    position: ${(props) => (props.isActive ? "absolute" : "static")};
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`;

const MofoPromise = styled.div`
  padding: 8px 0;
  color: #333333;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: opacity 1s ease-in-out;
  position: absolute;
  display: flex;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  &.active {
    opacity: 1;
    animation: ${(props) => (props.isActive ? fadeInOut : "")} 4s linear
      infinite;
  }

  @media ${({ theme }) => theme.mq.min.tablet} {
    position: static;
    padding-right: 10px;
    padding-left: 10px;
    opacity: 1;
    animation: none;
  }
`;

const MofoPromiseIcon = styled.div`
  width: 20px;
  height: 20px;
  line-height: 20px;
  margin-right: 5px;
  margin-left: 5px;
  opacity: 0.5;

  svg {
    width: 20px;
    height: 20px;
    fill: currentColor;
  }
`;

const MofoPromiseName = styled.div`
  font-size: 12px;
  font-family: Graphik, sans-serif;
  font-weight: 400;
  padding: 1px 0;
  line-height: 18px;
  color: #626468;

  strong {
    color: #77b204;
    font-weight: bold;
  }
`;

export const MofoPromises = () => {
  const market = process.env.GATSBY_VM_MARKET;
  const promises = marketPromises[market];
  const [activeGroup, setActiveGroup] = useState(0);
  const [activeItem, setActiveItem] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveItem((prevItem) => {
        const nextItem = prevItem === 2 ? 0 : prevItem + 1;
        if (nextItem === 0) {
          setActiveGroup((prevGroup) => (prevGroup === 1 ? 0 : 1));
        }
        return nextItem;
      });
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <MofoPromisesContainer>
      <MofoPromisesInner>
        {promises.map((group, index) => (
          <MofoPromisesGroup isActive={activeGroup === index} key={index}>
            {group.map(({ Icon, label, stats }, itemIndex) => (
              <MofoPromise
                className={
                  activeGroup === index && activeItem === itemIndex
                    ? "active"
                    : ""
                }
                key={itemIndex}
              >
                <MofoPromiseIcon>
                  <Icon size="10px" />
                </MofoPromiseIcon>
                <MofoPromiseName>
                  <strong>{stats}</strong> {label}
                </MofoPromiseName>
              </MofoPromise>
            ))}
          </MofoPromisesGroup>
        ))}
      </MofoPromisesInner>
    </MofoPromisesContainer>
  );
};